import {
  Automation,
  InsightEntityActivity,
  mockExecuteInsightEntityAutomationOperationMutation,
  mockInsightEntitiesByListIdsQueryOperationQuery,
  mockInsightEntityActivityQueryOperationQuery,
  mockInsightEntityAutomationsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockInsightEntityActivity: InsightEntityActivity[] = [
  {
    __typename: 'InsightEntityActivity',
    isPrimaryEntity: true,
    entityId: '_username-mgarst@proofpointdemo.com',
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    isPrimaryEntity: false,
    entityId: '_email-mgarst@proofpointdemo.com',
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    isPrimaryEntity: false,
    entityId: 'foobar-MESSAGE_BLOCKED',
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    isPrimaryEntity: false,
    entityId: '_ip-185.203.243.75',
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
];

export const mockEntitiesByListIds = [
  {
    __typename: 'EntityInterface' as const,
    entityType: '_username',
    entityTypeName: 'Username',
    id: '_username-mgarst@proofpointdemo.com',
    value: 'mgarst@proofpointdemo.com',
  },
  {
    __typename: 'EntityInterface' as const,
    entityType: '_email',
    entityTypeName: 'Email',
    id: '_email-mgarst@proofpointdemo.com',
    value: 'mgarst@proofpointdemo.com',
  },
  {
    __typename: 'EntityInterface' as const,
    entityType: 'foobar',
    entityTypeName: 'foobar',
    id: 'foobar-MESSAGE_BLOCKED',
    value: 'MESSAGE_BLOCKED',
  },
  {
    __typename: 'EntityInterface' as const,
    entityType: '_ip',
    entityTypeName: 'IP Address',
    id: '_ip-185.203.243.75',
    value: '185.203.243.75',
  },
];

export const mockAutomations: Automation[] = [
  {
    __typename: 'Automation',
    id: 'automation-1',
    playbookId: 'playbook-1',
    name: 'AbuseIPDB',
    description: 'IP Reputation',
    cseResourceType: 'ENTITY',
    cseResourceSubTypes: ['_ip', '_hostname'],
    executionTypes: ['NEW_INSIGHT', 'INSIGHT_CLOSED', 'ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
  {
    __typename: 'Automation',
    id: 'automation-2',
    playbookId: 'playbook-2',
    name: 'VirusTotal',
    description:
      'Scan File, IP Reputation, File Reputation, Domain Reputation, Get Alert Details',
    cseResourceType: 'ENTITY',
    cseResourceSubTypes: ['_username'],
    executionTypes: ['ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: false,
  },
  {
    __typename: 'Automation',
    id: 'automation-3',
    playbookId: 'playbook-3',
    name: 'Another Enrichment',
    description: 'This is just another enrichment',
    cseResourceType: 'ENTITY',
    cseResourceSubTypes: ['_username'],
    executionTypes: ['ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
  {
    __typename: 'Automation',
    id: 'automation-4',
    playbookId: 'playbook-4',
    name: 'Yet ANOTHER Enrichment',
    description: 'This is just another enrichment',
    cseResourceType: 'ENTITY',
    cseResourceSubTypes: ['_username'],
    executionTypes: ['ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
];

export const handlers = [
  // READ INSIGHT ENTITY ACTIVITY
  mockInsightEntityActivityQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightEntityActivity: mockInsightEntityActivity,
        },
      });
    }
  ),

  // READ ENTITIES BY LIST IDS
  mockInsightEntitiesByListIdsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          entitiesByListIds: mockEntitiesByListIds,
        },
      });
    }
  ),

  // READ INSIGHT AUTOMATIONS
  mockInsightEntityAutomationsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          automations: {
            __typename: 'AutomationPage',
            objects: mockAutomations,
          },
        },
      });
    }
  ),

  // EXECUTE INSIGHT AUTOMATION
  mockExecuteInsightEntityAutomationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          executeAutomation: {
            __typename: 'ExecuteAutomation',
            executionIds: ['playbook-1'],
            playbooksWithErrors: ['playbook-3', 'playbook-4'],
          },
        },
      });
    }
  ),
];
